import React, { createContext, useContext, useState } from 'react';
const context = /*#__PURE__*/createContext({
  provider: null,
  accessToken: {},
  setAccessToken: () => {}
});
export default context;
export const Provider = context.Provider;
export const Consumer = context.Consumer;
export const useAuth = () => useContext(context);
export const AuthProvider = _ref => {
  let {
    children,
    provider
  } = _ref;
  const initState = {
    provider,
    accessToken: '',
    setAccessToken: accessToken => {
      setState({ ...state,
        accessToken: accessToken
      });
    }
  };
  const [state, setState] = useState(initState);
  return /*#__PURE__*/React.createElement(Provider, {
    value: state
  }, children);
};
//# sourceMappingURL=index.js.map